import { GlobalState } from 'store/types';

export const posCampaignSelector = (proposalId: string) => (state: GlobalState) => ({
  data: state.pages.posCampaignSingle?.campaign?.data?.[proposalId],
  isLoading: state.pages.posCampaignSingle?.campaign?.pending[proposalId],
});
